import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import ContactModal from '../components/contact-modal'
import Footer from '../components/footer'
import Mark from '../components/mark'
import FAQ from '../components/faq'
import './home.css'

const EmployerBranding = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const [buttonSource, setButtonSource] = useState('')

  const openContactModal = (source = 'Unbekannt') => {
    setButtonSource(source)
    setIsContactModalOpen(true)
  }

  const closeContactModal = () => {
    setIsContactModalOpen(false)
  }

  return (
    <div className="home-container1">
      <Helmet>
        <title>Employer Branding Berlin | Starke Arbeitgebermarke für erfolgreiches Recruiting</title>
        <meta name="description" content="Professionelles Employer Branding in Berlin: Entwickeln Sie eine starke Arbeitgebermarke, die Talente anzieht. Ihre Experten für authentisches Employer Branding über Social Media." />
        <meta property="og:title" content="Employer Branding Berlin | Starke Arbeitgebermarke entwickeln" />
        <meta property="og:description" content="Ihre Experten für Employer Branding in Berlin. Wir helfen Ihnen, eine authentische Arbeitgebermarke aufzubauen, die qualifizierte Kandidaten begeistert." />
      </Helmet>
      
      <Navbar rootClassName="navbarroot-class-name" onContactClick={openContactModal}></Navbar>

      <section className="home-section10">
        <div className="home-hero">
          <div className="home-content1">
            <main className="home-main1">
              <header className="home-header10" >
                <h1 className="home-heading10">
                  Employer Branding: Werden Sie zum Magnet für Top-Talente mit einer starken Arbeitgebermarke
                </h1>
                <span className="home-caption1">
                  Als spezialisierte Social Recruiting Agentur in Berlin entwickeln wir authentische Employer Branding Strategien, die Ihre Arbeitgebermarke stärken und qualifizierte Bewerber anziehen. Von der Strategie über Content-Erstellung bis zur Umsetzung auf Social Media – wir machen Sie zum bevorzugten Arbeitgeber in Ihrer Branche.
                </span>
              </header>
              <div className="home-buttons1">
                <div className="home-get-started1 button" onClick={() => openContactModal('Employer Branding Beratung')} style={{ cursor: 'pointer' }}>
                  <span className="home-text10">Employer Branding Beratung</span>
                </div>
              </div>
            </main>
          </div>
          <div className="home-image13">
            <img
              alt="Employer Branding Berlin"
              src="/social-media-recruiting-agentur-erfolg.png"
              className="home-image14"
            />
          </div>
        </div>
      </section>

      <section className="home-section11" style={{ marginTop: '80px' }}>
        <h2 className="home-text12">
          Was ist Employer Branding und warum ist eine starke Arbeitgebermarke unverzichtbar?
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11" style={{ marginTop: '90px' }}>
                Die Bedeutung von Employer Branding im Kampf um die besten Talente
              </h2>
              <p className="home-paragraph1">
                <span>
                  Employer Branding bezeichnet den Aufbau und die Pflege einer attraktiven Arbeitgebermarke. Es geht darum, wie Ihr Unternehmen als Arbeitgeber wahrgenommen wird – von aktuellen Mitarbeitern, potenziellen Bewerbern und der Öffentlichkeit. In Zeiten des Fachkräftemangels ist eine starke Arbeitgebermarke nicht mehr nur Nice-to-have, sondern entscheidender Wettbewerbsvorteil. Als Social Recruiting Agentur in Berlin wissen wir: Unternehmen mit starkem Employer Branding erhalten nicht nur mehr Bewerbungen, sondern vor allem qualifiziertere Bewerbungen von Kandidaten, die wirklich zum Unternehmen passen.
                </span>
                <br></br>
                <br></br>
                <span>
                  Der Arbeitsmarkt hat sich fundamental gewandelt. Während Unternehmen früher aus einem Pool von Bewerbern wählen konnten, müssen sie heute aktiv um Talente werben. Kandidaten – besonders hochqualifizierte Fachkräfte – haben die Wahl zwischen mehreren Arbeitgebern und treffen ihre Entscheidungen zunehmend emotional: Passt die Unternehmenskultur zu mir? Fühle ich mich mit den Werten identifiziert? Bietet das Unternehmen die Entwicklungsmöglichkeiten, die ich suche? Eine authentische Arbeitgebermarke beantwortet diese Fragen und positioniert Ihr Unternehmen als attraktiven Arbeitgeber.
                </span>
                <br></br>
                <br></br>
                <span>
                  Employer Branding wirkt auf mehreren Ebenen: Extern macht es Ihr Unternehmen für potenzielle Bewerber sichtbar und attraktiv. Es differenziert Sie von Wettbewerbern und kommuniziert, was Sie als Arbeitgeber besonders macht. Intern stärkt eine klare Arbeitgebermarke die Identifikation Ihrer Mitarbeiter mit dem Unternehmen, erhöht die Mitarbeiterzufriedenheit und reduziert die Fluktuation. Zufriedene Mitarbeiter werden zu Markenbotschaftern, die authentisch über ihr Unternehmen sprechen – der effektivste Werbekanal überhaupt.
                </span>
                <br></br>
                <br></br>
                <span>
                  Als Social Recruiting Agentur mit Sitz in Berlin haben wir eine besondere Expertise in der Verbindung von Employer Branding und Social Media. Soziale Netzwerke sind heute der wichtigste Touchpoint zwischen Unternehmen und potenziellen Bewerbern. Hier informieren sich Kandidaten über potenzielle Arbeitgeber, hier teilen Mitarbeiter ihre Erfahrungen, hier entsteht die Wahrnehmung Ihrer Arbeitgebermarke. Professionelles Employer Branding auf Social Media ist deshalb kein optionaler Zusatz, sondern Kernbestandteil jeder erfolgreichen Recruiting-Strategie.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Employer Branding Strategie')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Employer Branding Strategie entwickeln →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Employer Branding Strategie"
              src="/social-media-recruiting-agentur-zusammenwirken.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Die Säulen erfolgreichen Employer Brandings</h2>
          <span className="home-text26">
            Als erfahrene Social Recruiting Agentur in Berlin entwickeln wir ganzheitliche Employer Branding Strategien, die auf diesen fundamentalen Säulen aufbauen.
          </span>
        </header>
        
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="Employer Value Proposition"
              src="/social-media-recruiting-agentur-wichtig.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">Employer Value Proposition</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  Definieren Sie Ihr einzigartiges Arbeitgeber-Versprechen
                </h2>
                <p className="section-description">
                  Die Employer Value Proposition (EVP) ist das Herzstück jeder Arbeitgebermarke. Sie beschreibt, was Ihr Unternehmen als Arbeitgeber einzigartig macht und welchen Mehrwert Sie Ihren Mitarbeitern bieten. Eine starke EVP ist authentisch, differenzierend und relevant für Ihre Zielgruppe. Als Social Recruiting Agentur helfen wir Ihnen, Ihre EVP zu entwickeln oder zu schärfen.
                  
                  Die Entwicklung einer überzeugenden EVP beginnt mit einer gründlichen Analyse: Was macht Ihre Unternehmenskultur aus? Welche Werte leben Sie? Welche Entwicklungsmöglichkeiten bieten Sie? Wie ist Ihr Führungsstil? Was schätzen Ihre aktuellen Mitarbeiter besonders? Durch Interviews mit Mitarbeitern, Workshops mit dem Management und Analysen Ihrer Wettbewerber identifizieren wir die Aspekte, die Ihr Unternehmen als Arbeitgeber wirklich auszeichnen.
                  
                  Wichtig ist, dass Ihre EVP nicht nur gut klingt, sondern auch gelebt wird. Leere Versprechen durchschauen Kandidaten schnell – auf Plattformen wie Kununu oder Glassdoor teilen Mitarbeiter ihre ehrlichen Erfahrungen. Authentizität ist deshalb entscheidend. Wir helfen Ihnen, eine EVP zu formulieren, die Ihre realen Stärken als Arbeitgeber widerspiegelt und gleichzeitig attraktiv für Ihre Wunsch-Kandidaten ist.
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('EVP entwickeln')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">EVP entwickeln lassen</span>
            </div>
          </div>
        </section>

        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Employer Branding Content"
              src="/social-media-recruiting-agentur-content.png"
              className="home-image22"
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Authentischer Content
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Content, der Ihre Arbeitgebermarke zum Leben erweckt
                  </h2>
                  <p className="section-description">
                    Eine EVP ist nur so gut wie ihre Kommunikation. Employer Branding lebt von authentischem Content, der Ihre Arbeitgebermarke erlebbar macht. Als Social Recruiting Agentur produzieren wir Content, der zeigt, wie es wirklich ist, in Ihrem Unternehmen zu arbeiten. Mitarbeiter-Testimonials sind besonders wertvoll: Lassen Sie Ihre Mitarbeiter selbst zu Wort kommen und über ihren Arbeitsalltag, ihre Entwicklung im Unternehmen und das, was sie an Ihrem Unternehmen schätzen, erzählen.
                    
                    Behind-the-Scenes-Content gibt authentische Einblicke in Ihren Unternehmensalltag. Zeigen Sie Teambesprechungen, Firmenevents, den Arbeitsalltag verschiedener Abteilungen oder besondere Momente im Unternehmensleben. Dieser Content wirkt deutlich authentischer als hochglanzpolierte Werbevideos und erzeugt eine emotionale Verbindung zu potenziellen Bewerbern. Video-Content performa auf Social Media besonders gut – Menschen verbringen mehr Zeit mit Videos und erinnern sich besser an Video-Inhalte.
                    
                    Aber auch andere Content-Formate sind wertvoll: Blogbeiträge zu Karrierethemen, Social Media Posts zu Unternehmenskultur und Werten, Einblicke in Projekte und Erfolge, oder Informationen zu Benefits und Entwicklungsmöglichkeiten. Der Content-Mix sollte vielfältig sein und verschiedene Facetten Ihrer Arbeitgebermarke beleuchten. Als Social Recruiting Agentur entwickeln wir Content-Strategien, die sowohl zur Plattform als auch zu Ihrer Zielgruppe passen.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Authentische Mitarbeiter-Testimonials und Interviews"></Mark>
                  <Mark label="Behind-the-Scenes Content und Alltagseinblicke"></Mark>
                  <Mark label="Plattform-optimierte Content-Formate für Social Media"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Content produzieren lassen')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Content produzieren lassen</span>
            </div>
          </div>
        </section>
      </section>

      <section className="home-section11">
        <h2 className="home-text12">
          Employer Branding auf Social Media: Erreichen Sie Talente dort, wo sie sind
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11">
                Wie Sie Ihre Arbeitgebermarke auf LinkedIn, Instagram und Facebook aufbauen
              </h2>
              <p className="home-paragraph1">
                <span>
                  <strong>LinkedIn als Employer Branding Plattform:</strong><br/>
                  LinkedIn ist die wichtigste Plattform für B2B-Employer Branding und die Ansprache von Fach- und Führungskräften. Eine professionell gestaltete LinkedIn-Unternehmensseite ist die Basis: Hier präsentieren Sie Ihr Unternehmen, teilen Updates und Insights und interagieren mit Ihrer Community. Die "Leben"-Sektion auf LinkedIn erlaubt detaillierte Einblicke in Ihre Unternehmenskultur, Benefits und Werte. Als Social Recruiting Agentur optimieren wir Ihre LinkedIn-Präsenz für maximale Wirkung.
                </span>
                <br></br>
                <br></br>
                <span>
                  Content-Formate für LinkedIn Employer Branding umfassen: Thought Leadership Content, in dem Ihre Führungskräfte Expertise teilen und Ihr Unternehmen als attraktiven Arbeitgeber positionieren. Employee Spotlights, die einzelne Mitarbeiter und ihre Geschichten in den Mittelpunkt stellen. Company Updates zu Erfolgen, neuen Projekten oder Unternehmensentwicklungen. Career-oriented Content mit Tipps für Bewerbungen, Informationen zu Einstiegsmöglichkeiten oder Einblicken in Karrierepfade. LinkedIn Articles, die tiefergehende Einblicke in Ihre Unternehmenskultur oder Branche geben.
                </span>
                <br></br>
                <br></br>
                <span>
                  Besonders wertvoll auf LinkedIn ist Employee Advocacy: Ermutigen und befähigen Sie Ihre Mitarbeiter, Content Ihres Unternehmens zu teilen und selbst über ihre Erfahrungen zu posten. Mitarbeiter-Posts erreichen deutlich mehr Menschen als Unternehmensposts und wirken authentischer. Als Social Recruiting Agentur entwickeln wir Employee Advocacy Programme, die Ihre Mitarbeiter zu aktiven Markenbotschaftern machen – ohne dass es sich für sie wie zusätzliche Arbeit anfühlt.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Instagram für emotionales Employer Branding:</strong><br/>
                  Instagram eignet sich perfekt für visuelles, emotionales Employer Branding. Besonders wenn Sie jüngere Zielgruppen (18-35 Jahre) ansprechen möchten, ist Instagram unverzichtbar. Die Plattform lebt von authentischen, ästhetisch ansprechenden Inhalten und ermöglicht verschiedene Content-Formate: Feed Posts für kurierte, hochwertige Inhalte. Stories für spontane, alltägliche Einblicke. Reels für kreative, unterhaltsame Short-Form-Videos. IGTV für längere Content-Formate wie Mitarbeiter-Interviews oder Behind-the-Scenes-Dokumentationen.
                </span>
                <br></br>
                <br></br>
                <span>
                  Instagram Employer Branding sollte weniger formal sein als auf LinkedIn. Zeigen Sie die menschliche Seite Ihres Unternehmens: das Team beim gemeinsamen Mittagessen, lustige Momente im Büro, Einblicke in Teambuilding-Events oder die Arbeitsumgebung. User Generated Content, bei dem Mitarbeiter selbst Content erstellen und teilen, funktioniert auf Instagram besonders gut. Mitarbeiter-Takeovers, bei denen ein Teammitglied für einen Tag den Instagram-Account übernimmt, bieten authentische Einblicke und erzeugen hohe Engagement-Raten.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Facebook für Community-Building und lokales Employer Branding:</strong><br/>
                  Obwohl Facebook bei jüngeren Zielgruppen an Relevanz verloren hat, bleibt es für viele Unternehmen wertvoll – besonders für lokales Employer Branding und die Ansprache von Zielgruppen 30+. Facebook ermöglicht umfangreiche Community-Interaktionen: Kommentare, Diskussionen und direkten Austausch mit Interessenten. Als Social Recruiting Agentur nutzen wir Facebook für verschiedene Employer Branding Aktivitäten.
                </span>
                <br></br>
                <br></br>
                <span>
                  Facebook-Gruppen sind besonders wertvoll für Employer Branding. Sie können eigene Gruppen für Alumni, Praktikanten oder Interessenten erstellen oder in relevanten Fachgruppen aktiv werden. Facebook Live ermöglicht virtuelle Office Tours, Q&A-Sessions mit dem HR-Team oder Live-Einblicke in Unternehmensevents. Facebook Jobs, das integrierte Recruiting-Tool, erlaubt es, Stellenanzeigen direkt auf Ihrer Unternehmensseite zu posten und mit Employer Branding Content zu kombinieren.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Social Media Strategie entwickeln')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Social Media Strategie entwickeln →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Social Media Employer Branding"
              src="/social-media-recruiting-agentur-linkedin.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Employee Advocacy: Machen Sie Ihre Mitarbeiter zu Markenbotschaftern</h2>
          <span className="home-text26">
            Die authentischsten Botschafter Ihrer Arbeitgebermarke sind Ihre eigenen Mitarbeiter. Als Social Recruiting Agentur in Berlin entwickeln wir Employee Advocacy Programme, die Ihre Mitarbeiter aktivieren.
          </span>
        </header>
        
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="Employee Advocacy Programme"
              src="/social-media-recruiting-agentur-gezielt.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">Employee Advocacy</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  Warum Mitarbeiter die besten Markenbotschafter sind
                </h2>
                <p className="section-description">
                  Employee Advocacy bezeichnet die systematische Aktivierung Ihrer Mitarbeiter als Markenbotschafter auf Social Media. Studien zeigen: Inhalte, die von Mitarbeitern geteilt werden, erreichen 8x mehr Engagement als Inhalte von Unternehmens-Accounts. Posts von Mitarbeitern werden als authentischer und vertrauenswürdiger wahrgenommen als Corporate Content. Zudem erweitert Employee Advocacy Ihre Reichweite erheblich – jeder Mitarbeiter hat sein eigenes Netzwerk, das Sie durch geteilte Inhalte erreichen.
                  
                  Ein erfolgreiches Employee Advocacy Programm erfordert mehr als nur die Aufforderung "Bitte teilt unsere Posts". Als Social Recruiting Agentur entwickeln wir strukturierte Programme, die Mitarbeiter befähigen, ermutigen und unterstützen. Das beginnt mit klaren Guidelines: Was dürfen und sollen Mitarbeiter teilen? Welcher Tone-of-Voice ist angemessen? Welche Themen sind relevant? Diese Guidelines schaffen Sicherheit und machen es Mitarbeitern leicht, aktiv zu werden.
                  
                  Wichtig ist auch, Mitarbeiter mit teilbarem Content zu versorgen. Wir erstellen Content-Bibliotheken mit vorgefertigten Posts, Grafiken und Texten, die Mitarbeiter mit einem Klick teilen können. Gleichzeitig ermutigen wir Mitarbeiter, eigenen, authentischen Content zu erstellen – über ihren Arbeitsalltag, spannende Projekte oder persönliche Entwicklungen im Unternehmen. Dieser selbsterstellte Content ist oft der wertvollste, da er besonders authentisch wirkt.
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('Employee Advocacy aufbauen')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">Employee Advocacy aufbauen</span>
            </div>
          </div>
        </section>

        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Mitarbeiter-Content erstellen"
              src="/social-media-recruiting-agentur-bereit.png"
              className="home-image22"
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Implementierung & Schulung
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Wie Sie Mitarbeiter zu aktiven Botschaftern entwickeln
                  </h2>
                  <p className="section-description">
                    Die Implementierung eines Employee Advocacy Programms beginnt mit Schulungen. Viele Mitarbeiter sind unsicher, was sie auf Social Media teilen dürfen oder wie sie sich präsentieren sollen. Als Social Recruiting Agentur bieten wir Workshops an, in denen wir Mitarbeiter schulen: Social Media Basics, Personal Branding, Content-Erstellung, Do's and Don'ts und die Nutzung von Tools. Diese Schulungen schaffen Sicherheit und Begeisterung.
                    
                    Gamification kann helfen, Mitarbeiter zu aktivieren: Leaderboards zeigen, wer besonders aktiv ist. Rewards und Anerkennung motivieren zur Teilnahme. Challenges und Wettbewerbe schaffen Anreize. Wichtig ist dabei, dass die Teilnahme freiwillig bleibt – erzwungene Aktivität wirkt unecht und schadet der Arbeitgebermarke eher, als dass sie nützt.
                    
                    Messung des Erfolgs ist wichtig: Welche Reichweite erzielen Mitarbeiter-Posts? Wie viel Engagement generieren sie? Führen sie zu Bewerbungen? Als Social Recruiting Agentur implementieren wir Tracking-Systeme, die den Erfolg Ihres Employee Advocacy Programms messbar machen. Diese Daten helfen, das Programm kontinuierlich zu optimieren und den ROI nachzuweisen.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Strukturierte Schulungs-Programme für Mitarbeiter"></Mark>
                  <Mark label="Content-Bibliotheken und Sharing-Tools"></Mark>
                  <Mark label="Performance-Tracking und Erfolgsmessung"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Schulung buchen')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Schulung buchen</span>
            </div>
          </div>
        </section>
      </section>

      <section className="home-section15">
        <header className="home-header13">
          <header className="home-left1">
            <span className="section-head">Unsere Employer Branding Expertise</span>
            <h2 className="section-heading">
              <span>Warum Unternehmen aus Berlin und ganz Deutschland</span>
              <br></br>
              <span>auf unsere Employer Branding Expertise vertrauen</span>
            </h2>
          </header>
          <div className="home-right1">
            <p className="home-paragraph4 section-description">
              Als spezialisierte Social Recruiting Agentur in Berlin haben wir hunderte Employer Branding Projekte erfolgreich umgesetzt. Vom Mittelstand bis zum Konzern – wir wissen, wie man authentische Arbeitgebermarken entwickelt und kommuniziert.
            </p>
          </div>
        </header>
      </section>

      <section className="home-section11">
        <h2 className="home-text12">
          Employer Branding Erfolgsmessung: So messen Sie den Erfolg Ihrer Arbeitgebermarke
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11">
                Die wichtigsten KPIs für Employer Branding
              </h2>
              <p className="home-paragraph1">
                <span>
                  Employer Branding ist kein Selbstzweck – es muss messbare Ergebnisse liefern. Als Social Recruiting Agentur legen wir großen Wert auf die Erfolgsmessung Ihrer Employer Branding Aktivitäten. Die wichtigsten KPIs umfassen verschiedene Bereiche: Bewerbungs-Metriken zeigen direkte Auswirkungen auf Ihr Recruiting. Anzahl der Bewerbungen: Steigt die Gesamtzahl der Bewerbungen? Qualität der Bewerbungen: Sind Bewerber besser qualifiziert? Time to Hire: Verkürzt sich die Zeit bis zur Stellenbesetzung? Cost per Hire: Reduzieren sich Ihre Recruiting-Kosten?
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Brand Awareness Metriken</strong> messen die Sichtbarkeit Ihrer Arbeitgebermarke: Reichweite auf Social Media, Impressions Ihrer Employer Branding Posts, Follower-Wachstum auf Ihren Karriere-Kanälen, Share of Voice im Vergleich zu Wettbewerbern. Engagement-Metriken zeigen, wie stark potenzielle Bewerber mit Ihrer Arbeitgebermarke interagieren: Likes, Kommentare und Shares auf Social Media, Engagement Rate Ihrer Posts, Video-Views und Watch Time, Click-Through-Rates auf Karriereseiten.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Reputation Metriken</strong> messen, wie Ihr Unternehmen als Arbeitgeber wahrgenommen wird: Bewertungen auf Kununu, Glassdoor und Google, Sentiment-Analysen von Social Media Mentions, Employee Net Promoter Score (eNPS), Antwortquoten auf Active Sourcing Anfragen. Website Metriken zeigen das Interesse an Ihrem Unternehmen als Arbeitgeber: Besucher auf Ihrer Karriereseite, Verweildauer und Seitenaufrufe, Conversion Rate (Karriereseiten-Besucher zu Bewerbungen), Traffic-Quellen (woher kommen Besucher?).
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Mitarbeiter-Metriken</strong> zeigen die interne Wirkung Ihrer Arbeitgebermarke: Mitarbeiterzufriedenheit und Engagement, Fluktuationsrate, Weiterempfehlungsrate (wie viele Mitarbeiter würden ihr Unternehmen als Arbeitgeber weiterempfehlen?), Teilnahme an Employee Advocacy Programmen. Als Social Recruiting Agentur implementieren wir Tracking-Systeme, die all diese Metriken erfassen und in verständlichen Dashboards visualisieren. So können Sie den Erfolg Ihrer Employer Branding Aktivitäten kontinuierlich monitoren und datenbasierte Optimierungen vornehmen.
                </span>
                <br></br>
                <br></br>
                <span>
                  Wichtig ist dabei ein ganzheitlicher Blick: Employer Branding wirkt oft nicht sofort, sondern entwickelt seine volle Wirkung über Zeit. Kurzfristige Metriken wie Social Media Engagement sind wichtig, aber langfristige Effekte wie verbesserte Bewerbungsqualität oder reduzierte Fluktuation sind der wahre Wert einer starken Arbeitgebermarke. Wir helfen Ihnen, beide Perspektiven zu berücksichtigen und den ROI Ihrer Employer Branding Investition nachzuweisen.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Erfolgsmessung implementieren')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Erfolgsmessung implementieren →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Employer Branding KPIs"
              src="/social-media-recruiting-agentur-funktion.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section19">
        <div className="home-cube1">
          <div className="home-top1 side"></div>
          <div className="home-front1 side"></div>
          <div className="home-left2 side"></div>
        </div>
        <main className="home-banner">
          <div className="home-header15">
            <h2 className="section-heading">
              Starten Sie jetzt mit professionellem Employer Branding
            </h2>
            <p className="home-description1 section-description">
              Lassen Sie uns gemeinsam eine Arbeitgebermarke entwickeln, die Top-Talente anzieht und Ihr Recruiting revolutioniert!
            </p>
          </div>
          <div className="home-buttons2">
            <div className="home-get-started5 button" onClick={() => openContactModal('Employer Branding starten')} style={{ cursor: 'pointer' }}>
              <span className="home-text32">Employer Branding starten</span>
            </div>
          </div>
        </main>
      </section>

      <section className="home-section26">
        <header className="home-header22">
          <span className="section-head">FAQ</span>
          <h2 className="home-heading26 section-heading">
            Häufig gestellte Fragen zu Employer Branding
          </h2>
        </header>
        <main className="home-accordion">
          <FAQ rootClassName="fa-qroot-class-name"></FAQ>
        </main>
      </section>

      <section className="home-section28">
        <main className="home-content6">
          <header className="home-header23">
            <h2 className="home-heading27 section-heading">
              Bereit für eine starke Arbeitgebermarke? Kontaktieren Sie uns!
            </h2>
            <div className="home-buttons3">
              <div className="home-ios button" onClick={() => openContactModal('Employer Branding Beratung')} style={{ cursor: 'pointer' }}>
                <span className="home-text50">Jetzt Beratung anfragen</span>
              </div>
            </div>
          </header>
          <img
            alt="Employer Branding Berlin"
            src="/social-media-recruiting-agentur-bereit2.png"
            className="home-image25"
          />
        </main>
      </section>

      <Footer activePage="employer-branding" />

      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} buttonSource={buttonSource} />
    </div>
  )
}

export default EmployerBranding
